/* eslint-disable no-useless-escape */
import { regex } from 'github-slugger/regex';

export function slugify(name: string) {
  return encodeURIComponent(
    name
      .toLowerCase()
      // Replace . and _ with -
      .replace(/[\.\_\!\,]+/g, '-')
      .replace(regex, '')
      .replace(/ /g, '-')
      // Replace multiple - with single -
      .replace(/\-\-+/g, '-')
      // Remove trailing -
      .replace(/-+$/g, ''),
  );
}
